"use client";
import { jsxs as h, jsx as v } from "react/jsx-runtime";
const t = ({
  title: H,
  titleId: i,
  desc: l,
  descId: r,
  ...e
}) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "flag-icons-by",
    viewBox: "0 0 640 480",
    "aria-labelledby": i,
    "aria-describedby": r,
    ...e,
    children: [
      l ? /* @__PURE__ */ v("desc", { id: r, children: l }) : null,
      H ? /* @__PURE__ */ v("title", { id: i, children: H }) : null,
      /* @__PURE__ */ v("defs", { children: /* @__PURE__ */ v("clipPath", { id: "by-a", children: /* @__PURE__ */ v("path", { d: "M0 0h200v608h8v284l-8 8H0z" }) }) }),
      /* @__PURE__ */ v("path", { fill: "#ce1720", strokeWidth: 2.07364, d: "M0 0h640v480H0Z" }),
      /* @__PURE__ */ h(
        "g",
        {
          fill: "#fff",
          clipPath: "url(#by-a)",
          transform: "matrix(.52885 0 0 .53333 5 0)",
          children: [
            /* @__PURE__ */ h("g", { id: "by-c", children: [
              /* @__PURE__ */ v(
                "path",
                {
                  id: "by-b",
                  d: "M36 0v14h-9v14H16v16H8v13H-8V24H8V6H-8V0Zm26 77v15h-8v12h-8V92h-8V77h-8V57h8V42h8V30h8v12h8v15h8v20Zm-17-1h10V58H45ZM19 183h8v-18h-8zm54 0h8v-18h-8ZM-8 305H6v13h6v16h9v15h12v-15h9v-16h8v-13H38v-15h21v10h13v17h11v19h-8v14h-7v13h-6v14h-9v12h-7v11h-9v14H24v-15h-9v-14H8v-9H-8v-23H8v-20H-8Z"
                }
              ),
              /* @__PURE__ */ v("use", { xlinkHref: "#by-b", transform: "matrix(-1 0 0 1 200 0)" }),
              /* @__PURE__ */ v("path", { d: "M96 0v32h8V0h32v14h-8v14h-12v16h-8v13H92V44h-8V28H72V14h-8V0Zm-2 274v-11h-6v-13h-7v-14h-8v-14h-8v-10h-9v-14H44v14h-9v10h-7v14h-8v14h-6v13H8v17H-8v-44H8v-20H-8v-33H8v14h10v14h10v-14h10v-14h8v-18h-8v-14H28v-14H18v14H8v14H-8v-41H8v-19H-8V77H8v13h8v16h11v13h9v15h7v12h14v-12h7v-15h9v-13h11V90h8V77h16v13h8v16h11v13h9v15h7v12h14v-12h7v-15h9v-13h11V90h8V77h16v28h-16v19h16v41h-16v-14h-10v-14h-10v14h-10v14h-8v18h8v14h10v14h10v-14h10v-14h16v33h-16v20h16v44h-16v-17h-6v-13h-6v-14h-8v-14h-7v-10h-9v-14h-12v14h-9v10h-8v14h-8v14h-7v13h-6v11zm2-167v27h8v-27zm-4 58v-14H82v-14H72v14H62v14h-8v18h8v14h10v14h10v-14h10v-14h16v14h10v14h10v-14h10v-14h8v-18h-8v-14h-10v-14h-10v14h-10v14zm4 46v27h8v-27z" })
            ] }),
            /* @__PURE__ */ v("use", { xlinkHref: "#by-c", transform: "matrix(1 0 0 -1 0 900)" }),
            /* @__PURE__ */ v("path", { d: "M-8 408H8v14h7v8h8v14h7v12h-7v14h-8v8H8v14H-8Zm216 0v84h-16v-14h-7v-8h-8v-14h-7v-12h7v-14h8v-8h7v-14ZM62 459h8v-18h-8zm76 0v-18h-8v18zm-42-59h8v-18h-8zm0 100v18h8v-18Zm-50-75h14v-11h10v-10h5v-10h6v-14h8v-14h4v-13h14v13h4v14h8v14h6v10h5v10h10v11h14v50h-14v11h-10v10h-5v10h-6v14h-8v14h-4v13H93v-13h-4v-14h-8v-14h-6v-10h-5v-10H60v-11H46Zm50 9v-15h-8v-10h-8v25h8v9h5v14h-5v9h-8v25h8v-10h8v-15h8v15h8v10h8v-25h-8v-9h-5v-14h5v-9h8v-25h-8v10h-8v15z" })
          ]
        }
      ),
      /* @__PURE__ */ v("path", { fill: "#007c30", strokeWidth: 2.00749, d: "M110 320h530v160H110Z" })
    ]
  }
);
export {
  t as default
};
